<!-- new card design -->
<!--@@ START MULTIPLE IMAGE POST  @@-->
<!-- verify post -->
<!-- {{feedObject?.channel?.content_visibility | json}} -->



    <div [id]="'sugestion-feed-'+feedObj?.feed_id" class="position-relative feed-card-container">
        <div *ngIf="loginUserCustomeId==feedObject?.user_profile?.custom_id  && feedObject?.verify_card?.type=='not_verified'"
        [id]="'sugestion-feed-'+feedObj?.feed_id" 
            class="bg-white p-3 not_verified_card verification-process position-relative mb-3 container-shadow ">
            <div class="row">
                <div class="col-2 pr-0">
                    <img class="responsive-img" src="assets/themes/images/not-verified-nudge.svg"
                    width="58px" />
                </div>

                <div class="col-md-6 pl-0 secondary-paragraph">
                    <p class="pl-2 paragraph-bold">
                        {{feedObject?.verify_card?.heading_text}}
                    </p>

                    <p class="pl-2 paragraph-bold">
                        {{feedObject?.verify_card?.description_text}}
                    </p>
                </div>

                <div class="col-4 text-right">
                    <button (click)="assignAssociation()"
                        class="btn-design small filled mt-3 d-inline-block">{{feedObject?.verify_card?.button?.text}}</button>
                </div>
            </div>
            <!-- icon -->
        </div>
        <!-- end verify post -->

        <div class="postbox-container pb-2 bg-white" [ngClass]="{'container-shadow':callingfrom !== createRepostScreen && callingfrom !== createUserStoryScreen,'repost-card-border':callingfrom === createRepostScreen || callingfrom === createUserStoryScreen}"
          *ngIf="feedObject !== null">
            <div class="post-comment-band px-3 py-2 rounded-corner-12 separator-line-btm" *ngIf="callingfrom !== createRepostScreen && callingfrom !== createUserStoryScreen"
              [ngClass]="{'ec-badge-container pb-5': !isEditorsChoiceList && isEditorsChoicePost}"
              [style.background-image]="!isEditorsChoiceList && isEditorsChoicePost && feedObj.editor_choice_data.headers?.color | gradient: gradientDirection.BOTTOM">
                <p class="clearfix secondary-paragraph-bold" [ngClass]="{'flex-v-center': !isEditorsChoiceList && isEditorsChoicePost}">
                    <span class="color-grey-700"
                        [ngClass]="{'flex-grow-2x': !isEditorsChoiceList && isEditorsChoicePost}">{{textHeighlight}}</span>
                    <ng-container *ngIf="!isEditorsChoiceList && isEditorsChoicePost">
                      <span class="flex-v-center mr-2 ec-badge">
                        <img loading="lazy" class="ec-badge-icon"
                            [src]='this.feedObj.editor_choice_data.headers?.images.icon | fitInImg :igs.imageGroup.fitin_500x500'
                            alt="ec badge icon"/>
                        <span class="ec-text ec-text-overflow paragraph-bold"
                            [title]="this.feedObj.editor_choice_data.headers?.highlight_text">
                          {{this.feedObj.editor_choice_data.headers?.highlight_text || ''}}
                        </span>
                      </span>
                    </ng-container>

                    <span *ngIf="callingFrom === screenName.COMMUINIY_DETAILS && feedObject?.is_pinned"
                     class="post-edit-link float-left position-relative">
                     <img src="assets/themes/icons/pin-post.svg" alt="pinned" />
                   </span>
                    <span class="post-edit-link float-right position-relative"
                        [ngClass]="{'top-4':!isEditorsChoiceList && isEditorsChoicePost}"
                        >
                        <div ngbDropdown class="d-inline-block">
                            <a *ngIf="(this.mls.featureOnOffList.featureList.report.value || !mls.userLoginFlow)" class="lnguage-selector cursor-pointer" id="editPost" ngbDropdownToggle>
                                <img src="assets/themes/icons/kabab-menu-icon.svg" class="horizontal-menu pr-3 margin-top-24px" alt=" menu icon" />
                            </a>

                            <div ngbDropdownMenu aria-labelledby="editPost"
                                class="ngb-dropdown-list pt-2 pb-2">
                                <div class="text-left pl-0 w-100 pr-0 pb-2 px-3 list-hover cursor-pointer"
                                    (click)="pinUnpinPost(feedObject?.feed_id, feedObject?.is_pinned)"
                                    *ngIf="isCommunityAdmin && callingFrom === screenName.COMMUINIY_DETAILS && !feedObject?.is_pinned">
                                    {{mls.languageText.community.key157}}
                                </div>
                                <div class="text-left pl-0 w-100 pr-0 pb-2 px-3 list-hover cursor-pointer"
                                    (click)="pinUnpinPost(feedObject?.feed_id, feedObject?.is_pinned)"
                                    *ngIf="isCommunityAdmin && callingFrom === screenName.COMMUINIY_DETAILS && feedObject?.is_pinned">
                                    {{mls.languageText.community.key158}}
                                </div>
                                <button
                                    [disabled]="isPostButtonDisable"
                                    *ngIf="loginUserCustomeId==feedObject?.user_profile?.custom_id && feedObject?.feed_kind!='poll'"
                                    (click)="editFeed(feedObject)"
                                    class="tooltip-list text-left pl-0 w-100 pr-0 pb-2 px-3 pt-0 list-hover cursor-pointer btn">
                                    <!-- TODO: btn remove-->
                                    <span>{{mls.languageText.feed_card_screen.key3}}</span>
                                    <span *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key3)</span>
                                    <span *ngIf="isPostButtonDisable" class="tooltiptext">{{mls.languageText.post_process.key7}}</span>
                                </button>

                                <div *ngIf="loginUserCustomeId==feedObject?.user_profile?.custom_id"
                                    class="text-left pl-0 w-100 pr-0 pb-2 px-3 list-hover cursor-pointer"
                                    (click)="onDeletePost()"
                                    >{{mls.languageText.feed_card_screen.key4}}<span
                                        *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key4)</span></div>

                                <div class="text-left pl-0 w-100 pr-0 pb-2 px-3 list-hover cursor-pointer"
                                    (click)="funCollectionService.openReportModal(1, feedObject?.feed_id);reportPost()">{{mls.languageText.feed_card_screen.key1}}<span
                                    *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key1)</span></div>
                                <div class="text-left pl-0 w-100 pr-0 pb-2  px-3 list-hover cursor-pointer"
                                    (click)="onDeleteCommunityPost($event);"
                                    *ngIf="isCommunityAdmin && (productType.COMMUNITY === ptoductType)">
                                    {{mls.languageText.community.key109}}
                                </div>
                            </div>
                        </div>
                    </span>
                </p>
            </div>
            <div></div>
            <div>
             <!--masking div-->
            <div class="position-absolute w-100 h-100 masking-div masking-div-rounded"
                *ngIf="feedObject?.channel?.content_visibility?.display==0 || feedObject?.channel?.content_visibility?.display==2 || feedObject?.hl?.mcnt">
                <app-product-masking-card
                    [content_visibility]="feedObject?.channel?.content_visibility" [communityVisible]="feedObject?.hl?.mcnt">
                </app-product-masking-card>
            </div>
            <!--  user card -->
            <div class="p-3 cnnction-rqst">
                <app-connection-card [usercardsize]="'gr'"
                [callingfrom]="callingfrom"
                *ngIf="feedObject?.user_profile!=null && feedObject?.channel==null"
                [suggObj]="feedObject.user_profile"
                [is_anonymous]="feedObject.is_anonymous"
                (resetSuggList)=resetSuggList($event)
                [product]="feedObject"
                [posted_in]="postedIn"
                [isPostedEvent]="isPostedEvent"
                (emitOpenFeed)="handleOpenFeedEvent($event);"
                (emitCommunityDetail)="handleCommunityDetailEvent($event)">
                </app-connection-card>

                <app-channel-user-card
                    [screenName]="callingfrom"
                    [productType]="productTypeConstant.FEED"
                    [productTypeId]="feedObject?.product_type_id"
                    [removechannelfollow]='callingfrom'
                    *ngIf="feedObject?.channel!=null"
                    [usercardsize]="'m'"
                    [callingFrom]="'feed_card'"
                    [data]="feedObject?.channel">
                </app-channel-user-card>
                <!-- annonymous -->
                <!-- community user card -->
                <div *ngIf="feedObject?.hl?.n" class="d-flex justify-content-between connectionCard">
                    <div class="pr-0 d-flex" (click)="redirectToCommunityDetail(feedObject?.hl?.code)">
                        <div class="float-left mr-2 profile-min-width cursor-pointer">
                            <div class="position-relative user-profile-pic-container">
                                <img class="rounded-circle box-size-40 post-pic"  [src]="feedObject?.hl?.l" onError="this.src='assets/themes/images/create-community-placeholder.svg';">
                            </div>
                        </div>
                        <div class="float-left pl-0 grandroundCardTextWidth cursor-pointer text-capitalize secondary-paragraph-bold">
                            {{feedObject?.hl?.n}}
                        </div>
                    </div>
                </div>

            </div>

            <div class="px-3 mt-2 mb-2"
                                    (click)="showFeedDetail(0);">
                                    <app-content-card
                                        class="cursor-pointer paragraph"
                                        [cmt]="feedObject?.content"
                                        [showChar]="150"
                                        [isActionBlock]=true
                                        [analyticsFeedData]="analyticsFeedData"
                                        [analyticsFeedViewMoreData]="analyticsFeedViewMoreData"
                                        [callingfrom]="callingfrom">
                                    </app-content-card>

                                    <!--HTML CONTENT-->
                                    <div 
                                        *ngIf="feedObject?.html_content!='' && feedObject?.html_content!=undefined"
                                        [innerHtml]="feedObject?.html_content | safehtml">
                                    </div>

                                    <!--EOF HTML CONTENT-->
                                </div>



            <!-- end user card -->
            <div class="position-relative">
                <div class="postbox-content">
                    <div class="member-post">
                        <div *ngIf="feedObject?.meta_url!='' && feedObject?.meta_array!='' " class="link-post d-flex flex-column meta-container">
                            <a *ngIf="feedObject?.meta_array?.images!=false" href="{{feedObject?.meta_array?.pageUrl}}"
                                target="_blank" class="singleimg-link d-flex justify-content-center img-container">

                                <img loading="lazy" [src]="feedObject?.meta_array?.images | fitInImg :igs.imageGroup.fitin_500x500" class="post-pic thumbnail-image"
                                    onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" alt="link-image">
                            </a>
                            <a href="{{feedObject?.meta_array?.pageUrl}}"
                            target="_blank">
                            <div class="px-3 bg-blue-100 link-post-description cursor-pointer">
                                <ng-container *ngIf="feedObject?.meta_array?.title; else canonicalName">
                                    <h5 class="link-title">
                                        <a class="paragraph-bold meta-title"
                                            
                                            href="{{feedObject?.meta_array?.pageUrl}}" target="_blank"
                                            innerHTML="{{feedObject?.meta_array?.title}}"></a>
                                    </h5>
                                </ng-container>
                                <ng-template #canonicalName>
                                    <h5 class="link-title" *ngIf="feedObject?.meta_array?.canonicalUrl">
                                        <a class="d-block paragraph-bold meta-title"
                                        href="{{feedObject?.meta_array?.pageUrl}}"
                                            
                                            target="_blank">{{funCollectionService.extractCanonicalUrl(feedObject?.meta_array?.canonicalUrl)}}</a></h5>
                                </ng-template>
                                <ng-container *ngIf="feedObject?.meta_array?.description">
                                    <a href="{{feedObject?.meta_array?.pageUrl}}"
                                        
                                        target="_blank">
                                        <p class="primary-small color-grey-500 link-desc meta-description" innerHTML="{{ feedObject?.meta_array?.description }}"></p>
                                    </a>
                                </ng-container>
                            </div>
                            <div class="link-text px-3 ">
                                <a *ngIf="feedObject?.meta_array?.canonicalUrl"
                                     href="{{feedObject?.meta_array?.pageUrl}}"
                                    target="_blank"
                                    innerHTML="{{ feedObject?.meta_array?.canonicalUrl }}"
                                    class="primary-small">
                                </a>
                            </div>
                        </a>
                        </div>
                        <div id="tempd" style="display:none;"></div>
                        <!-- link Meta post end -->

                        <!--Media Posting -->
                        <div *ngIf="feedObject?.media_list?.length>0" class="multiple-media-post">
                            <!-- ========== post single image======== -->
                            <div *ngIf="feedObject?.media_list?.length==1" class="single_image">
                                <div class="img-relative">
                                    <a class="singleimg-link" href="javascript:void(0);"
                                        *ngIf="feedObject?.media_list[0].media_type!='youtube' &&  feedObject?.media_list[0].media_type!='audio'" >
                                        <img loading="lazy" (click)="funCollectionService.stopEventPropagation();mediaClicked(0)" class="position-absolute toast-center-center play-icon"
                                            *ngIf="feedObject?.media_list[0].media_type=='video'"
                                            src="assets/themes/icons/video-play-icon.svg" />

                                        <i (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                            
                                            *ngIf="feedObject?.media_list[0].media_type=='document'"
                                            class="fas fa-file-pdf bg-tanspernt h-100"></i>

                                        <img loading="lazy" *ngIf="feedObject?.media_list[0]?.media_type!='video'"
                                            class="post-pic"
                                            
                                            (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                            src="{{(feedObject?.media_list[0]?.media_type=='image' ? feedObject?.media_list[0]?.media_url : feedObject?.media_list[0]?.media_thumbnail) | fitInImg :igs.imageGroup.fitin_500x500}}"
                                            (error)=defaultMediaService.errorHandler($event,feedObject?.media_list[0].media_type)>
                                        <!--single video start-->
                                        <div *ngIf="feedObject?.media_list[0]?.media_type=='video'">
                                            <img loading="lazy" (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                                [src]="feedObject?.media_list[0]?.media_thumbnail | fitInImg :igs.imageGroup.fitin_500x500"
                                                class="post-pic"
                                                onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'">
                                        </div>
                                        <!--single video end-->

                                    </a>
                                    <!-- audio posting start-->
                                    <div class="bg-single ml-2 mr-2 cursor-pointer"
                                        (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                        *ngIf="feedObject?.media_list[0].media_type=='audio'">
                                        <img class="position-absolute toast-center-center play-icon"
                                            src="assets/themes/icons/video-play-icon.svg"/>
                                    </div>


                                    <a class="singleimg-link" href="javascript:void(0);"
                                        *ngIf="feedObject?.media_list[0]?.media_type=='youtube' " (click)="f1()">
                                        <img loading="lazy" *ngIf="hide_youtube_thumbnail==false" src="assets/themes/images/img-video-loader.gif"
                                            data-src="{{feedObject?.media_list[0].media_thumbnail}}"
                                            (error)="setYoutubeMedia()">
                                        <div class="youtubevideo" [innerHtml]="iframe_html"></div>
                                    </a>
                                </div>
                            </div>
                            <!-- ========post two or more image========= -->
                            <div  [ngClass]="{'d-flex': callingfrom === createUserStoryScreen, 'd-block': callingfrom != createUserStoryScreen}" *ngIf="feedObject?.media_list?.length>1">
                                <div class="mip-left" [ngClass]="{'d-inline-block': callingfrom !== createUserStoryScreen }" >
                                    <div class="img-relative">
                                        <a *ngIf="feedObject?.media_list[0].media_type!='audio'"
                                            class="img-link cursor-pointer" [ngClass]="{'create-story': callingfrom === createUserStoryScreen &&  feedObject?.media_list?.length == 2, 'create-story-multiple':callingfrom === createUserStoryScreen && feedObject?.media_list?.length>2 }" >
                                            <img loading="lazy" (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                                class="position-absolute toast-center-center play-icon"
                                                *ngIf="feedObject?.media_list[0].media_type=='video'"
                                                src="assets/themes/icons/video-play-icon.svg" />
                                            <img loading="lazy" (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                                
                                                src="{{(feedObject?.media_list[0].media_type=='image' ? feedObject?.media_list[0]?.media_url : feedObject?.media_list[0]?.media_thumbnail) | fitInImg :igs.imageGroup.fitin_500x500}}"
                                                (error)=defaultMediaService.errorHandler($event,feedObject?.media_list[0].media_type)>

                                            <i (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                                
                                                class="fas fa-file-pdf bg-tanspernt"
                                                *ngIf="feedObject?.media_list[0].media_type=='document'">
                                            </i>
                                        </a>
                                        <!-- audio posting start-->
                                        <div class="bg"
                                            (click)="funCollectionService.stopEventPropagation();mediaClicked(0)"
                                            *ngIf="feedObject?.media_list[0].media_type=='audio'">
                                            <i (click)="funCollectionService.stopEventPropagation();mediaClicked(0)" class="bg-tanspernt d-block position-relative"
                                                *ngIf="feedObject?.media_list[0].media_type=='audio'">
                                                <img class="position-absolute toast-center-center play-icon"
                                                    src="assets/themes/icons/video-play-icon.svg" />
                                            </i>
                                        </div>
                                        <!-- audio posting end-->
                                    </div>
                                </div>
                                <div class="mip-right" [ngClass]="{'multipleImage-right': feedObject?.media_list?.length>2, 'd-inline-block': callingfrom !== createUserStoryScreen }">
                                    <div class="img-relative"
                                        [ngClass]="{'multipleImageTH': feedObject?.media_list?.length==2 && callingfrom != createUserStoryScreen }">
                                        <a *ngIf="feedObject?.media_list[1].media_type!='audio'"
                                            class="img-link" [ngClass]="{'multiple-image-story': callingfrom == createUserStoryScreen && feedObject?.media_list?.length > 2, 'create-story': callingfrom === createUserStoryScreen && feedObject?.media_list?.length==2 }" href="javascript:void(0);">
                                            <img class="position-absolute toast-center-center play-icon"
                                                 (click)="funCollectionService.stopEventPropagation();mediaClicked(1)"
                                                *ngIf="feedObject?.media_list[1].media_type=='video'"
                                                src="assets/themes/icons/video-play-icon.svg" />

                                            <img loading="lazy" *ngIf="feedObject?.media_list[1].media_type!='audio' "
                                                (click)="funCollectionService.stopEventPropagation();mediaClicked(1)"
                                                
                                                src="{{(feedObject?.media_list[1].media_type=='image' ? feedObject?.media_list[1]?.media_url : feedObject?.media_list[1]?.media_thumbnail) | fitInImg :igs.imageGroup.fitin_500x500}}"
                                                (error)=defaultMediaService.errorHandler($event,feedObject?.media_list[1].media_type)>

                                            <i href="javascript:void(0);"
                                                (click)="funCollectionService.stopEventPropagation();mediaClicked(1)"
                                                class="fas fa-file-pdf threeimgPdf "
                                                *ngIf="feedObject?.media_list[1].media_type=='document'">
                                            </i>
                                        </a>
                                        <div class="bg" *ngIf="feedObject?.media_list[1].media_type=='audio'"
                                            (click)="funCollectionService.stopEventPropagation();mediaClicked(1)">
                                            <img class="position-absolute toast-center-center play-icon"
                                                src="assets/themes/icons/video-play-icon.svg" />
                                        </div>
                                    </div>
                                    <div *ngIf="feedObject?.media_list?.length>2" class="img-relative">
                                        <a *ngIf="feedObject?.media_list[1].media_type!='audio' " class="img-link"
                                        [ngClass]="{'multiple-image-story ': callingfrom === createUserStoryScreen}"
                                            href="javascript:void(0);" (click)="funCollectionService.stopEventPropagation();mediaClicked(2)">
                                            <img class="position-absolute toast-center-center play-icon"
                                                (click)="funCollectionService.stopEventPropagation();mediaClicked(2)"
                                                *ngIf="feedObject?.media_list[2].media_type=='video'"
                                                src="assets/themes/icons/video-play-icon.svg" />

                                            <img
                                                *ngIf="feedObject?.media_list[2].media_type!='audio' "
                                                src="assets/themes/icons/primary-loader.gif"
                                                height="20"
                                                width="20"
                                                data-src="{{(feedObject?.media_list[2].media_type=='image' ? feedObject?.media_list[2]?.media_url : feedObject?.media_list[2]?.media_thumbnail) | fitInImg :igs.imageGroup.fitin_500x500}}"
                                                (error)=defaultMediaService.errorHandler($event,feedObject?.media_list[2].media_type)>
                                                <i href="javascript:void(0);"
                                                    (click)="funCollectionService.stopEventPropagation();mediaClicked(2)"
                                                    class="fas fa-file-pdf threeimgPdf "
                                                    *ngIf="feedObject?.media_list[2].media_type=='document'">
                                                </i>

                                            <span *ngIf="feedObject?.media_list?.length>3"
                                                class="img-count">+{{ feedObject?.media_list?.length-3 }}
                                                {{mls.languageText.feed_card_screen.key15}}<span
                                                    *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key15)</span></span>

                                            <div class="bg"
                                                *ngIf="feedObject?.media_list[2].media_type=='audio'"
                                                (click)="funCollectionService.stopEventPropagation();mediaClicked(2)">
                                                <img class="position-absolute toast-center-center play-icon"
                                                    *ngIf="feedObject?.media_list?.length==3"
                                                    src="assets/themes/icons/video-play-icon.svg" />
                                                <span *ngIf="feedObject?.media_list?.length>3"
                                                    class="img-count">+{{ feedObject?.media_list?.length-3 }}
                                                    {{mls.languageText.feed_card_screen.key15}}<span
                                                    *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key15)</span>
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- ========End multiple three image========= -->
                        </div>
                        <!--Eof Media Posting -->

                        <div class="px-3">
                            <div>
                                <!--title-->
                                <div class="mt-2 mb-2 heading-4">
                                    <div class="color-black cursor-pointer"
                                        (click)="showFeedDetail(0);"
                                        *ngIf="feedObject?.title!='' && feedObject?.title!=undefined"
                                        [innerHtml]="feedObject?.title | safehtml">
                                    </div>
                                </div>



                                <!-- new poll design -->
                                <div class="poll-post mt-2" *ngIf="feedObject?.feed_kind=='poll' ">
                                    <ul>
                                        <!-- without selected -->
                                        <li class="p-3 mb-3 cursor-pointer position-relative poll-item" [ngClass]="{'filled-percentage-bar-border':feedPoll?.mypoll==1 }"
                                            *ngFor="let feedPoll of feedObject?.poll; let idx=index;">

                                            <!-- without image-->
                                            <div class="position-relative"
                                                style="z-index: 1;"
                                                (click)="PollOnFeed(feedObject?.feed_id,feedPoll?.option_id,feedObject?.poll_status,idx)"
                                                >
                                                <div class="row">
                                                    <div *ngIf="feedPoll?.file_url==''"
                                                        [ngClass]="{'col-12':feedObject?.poll_status==0 && !feedObject?.is_author, 'col-8':feedObject?.poll_status==1 || feedObject?.is_author}">
                                                        <div
                                                            [ngClass]="{'secondary-paragraph':feedObject?.poll_status==1 || feedObject?.is_author, 'secondary-paragraph':feedObject?.poll_status==0}">
                                                            <span class="font-weight-600">{{feedPoll?.options}}</span><span
                                                                *ngIf="feedPoll?.mypoll==1" class="ml-3"><img width="24" height="24"
                                                                    src="assets/themes/icons/poll-tick-icon.svg" />
                                                                </span>
                                                        </div>
                                                    </div>
                                                    <!-- with media -->
                                                    <div *ngIf="feedPoll?.file_url!=''"
                                                        [ngClass]="{'col-12':feedObject?.poll_status==0 && !feedObject?.is_author, 'col-8':feedObject?.poll_status==1 || feedObject?.is_author}">
                                                        <div class="poll-option-img float-left mr-2 rounded-corners-12">
                                                            <img   loading="lazy" [src]="feedPoll?.file_url | fitInImg :igs.imageGroup.fitin_500x500"
                                                                onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
                                                        </div>

                                                        <div class="float-left pt-2 w-75">
                                                            <span
                                                                [ngClass]="{'secondary-paragraph':feedObject?.poll_status==1 || feedObject?.is_author, 'secondary-paragraph':feedObject?.poll_status==0}">
                                                                <span class="font-weight-600">{{feedPoll?.options}}</span><span
                                                                *ngIf="feedPoll?.mypoll==1"><img width="24" height="24" class="ml-2"
                                                                    src="assets/themes/icons/poll-tick-icon.svg" /></span></span>
                                                        </div>
                                                    </div>
                                                    <div class="col-4 text-right"
                                                        *ngIf="feedObject?.poll_status==1 || feedObject?.is_author"
                                                        [ngClass]="{'pt-2':feedPoll?.file_url!='' }">
                                                        <span class="secondary-paragraph-bold">{{feedPoll?.per}}%</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <!-- percentage bar -->
                                            <div class="h-100" [ngClass]="{'percentage-bar': feedPoll?.per !== '0.00','filled-percentage-bar-background':feedPoll?.mypoll==1 }"
                                                [ngStyle]="getMyStyles(feedPoll?.per, feedObject?.poll_status, feedObject?.is_author)"></div>
                                        </li>
                                    </ul>

                                </div>
                                <!-- end new poll  -->

                                <!--Tagged users component start-->
                                <ng-container *ngIf="feedObject?.user_tagged?.length">
                                    <app-tagged-users
                                        [taggedUsers]="feedObject.user_tagged"
                                        [limit]="numbers.TWO"
                                        (postDetail)="showFeedDetail(numbers.ZERO)">
                                    </app-tagged-users>
                                </ng-container>
                                <!--Tagged users component end-->

                                <!--Speciality Tagging-->
                                <div class="post-tags pb-1"  *ngIf="feedObject?.speciality?.length>0">
                                    <span
                                      *ngFor="let Sl of feedObject?.speciality;"
                                      class="mr-2 cursor-pointer secondary-paragraph d-inline-block">
                                        <span class="color-grey-500"  (click)="getSpecialty(Sl); funCollectionService.stopEventPropagation(); ">
                                          #{{ Sl?.speciality_name }}
                                        </span>
                                    </span>
                                </div>
                                <!--End of Speciality Tagging-->

                                <h6 *ngIf="feedObject?.classification=='pharma'"
                                    class="powerd-tags">
                                    <img
                                        class="powred-logo"
                                        [src]="feedObject?.target_image | imagefilter:'./assets/images/placeholder_logo.png'"
                                        onError="this.src='./assets/images/placeholder_logo.png';">{{ feedObject?.target_label }}
                                </h6>


                                <!-- start button get sample -->
                                <a *ngIf="feedObject?.classification=='pharma' && feedObject?.drug_sample"
                                    class="btn-design small filled"
                                    (click)="showGetsamplePopup()">{{mls.languageText.feed_card_screen.key13}}<span
                                        *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key13)</span></a>
                                <!-- end button get sample -->
                            </div>

                            <!-- Repost card start -->
                            <div class="p-2 border rounded"
                                *ngIf="feedObject.repost_content !== null && (feedObject?.repost_content?.product_type === productTypeConstant.WEBINAR)">
                                <app-webinar-card
                                    [callingfrom]="callingfrom === createUserStoryScreen ? createUserStoryScreen : createRepostScreen"
                                    [docCardObj]="feedObject?.repost_content?.data"
                                    [parentEntityType]="productTypeConstantName.FEED"
                                    [parentEntityCode]="feedObject?.feed_id"
                                    [docTalkSection]=''
                                    [listLength]="1">
                                </app-webinar-card>
                            </div>

                            <div class="p-2 border rounded"
                                *ngIf="feedObject.repost_content !== null && feedObject?.repost_content?.product_type === productTypeConstant.DOCTALKS">
                                <app-web-doctalk-card
                                  appear
                                  [callingfrom]="callingfrom === createUserStoryScreen ? createUserStoryScreen : createRepostScreen"
                                  [parentEntityType]="productTypeConstantName.FEED"
                                  [parentEntityCode]="feedObject?.feed_id"
                                  [docCardObj]='feedObject.repost_content.data'
                                  [docTalkSection]='"features_videos"'
                                  [listLength]=2>
                                </app-web-doctalk-card>
                            </div>


                            <div class="p-2 border rounded"
                                *ngIf="feedObject.repost_content !== null && feedObject?.repost_content?.product_type === productTypeConstant.ARTICLE">
                                <app-clinical-resource-card
                                appear
                                [parentEntityType]="productTypeConstantName.FEED"
                                [parentEntityCode]="feedObject?.feed_id"
                                [callingfrom]="callingfrom === createUserStoryScreen ? createUserStoryScreen : createRepostScreen"
                                [clinicalObj]="feedObject.repost_content.data"
                                [idx]="0">
                              </app-clinical-resource-card>
                            </div>



                            <div class="postbox mb-2 secondary-paragraph repost_disabled"
                                *ngIf="feedObject.repost_content !== null && feedObject?.repost_content?.product_type === productTypeConstant.FEED">
                                <app-feed-card
                                    appear
                                    [callingfrom]="callingfrom === createUserStoryScreen ? createUserStoryScreen : createRepostScreen"
                                    [feedObj]="feedObject.repost_content.data"
                                    [source]="numbers.ONE"
                                    [ptoductType]="numbers.ONE"
                                    [parentFeedId]="feedObj.product_type_id"
                                    [feedIdx]="numbers.ONE"
                                    [textHeighlight]=""
                                    [flags]="numbers.ONE"
                                    (feedSpecialty)="getSpecialty($event)">
                                </app-feed-card>
                            </div>

                            <div *ngIf="feedObject.repost_info?.is_available === numbers.ZERO"
                                class="postbox mb-2 rounded repost_disabled p-3 deleted-info">
                                <p class="secondary-paragraph font-weight-600 pb-2 ">{{feedObject.repost_info?.message?.title}}</p>
                                <p class="primary-small font-weight-500">{{feedObject.repost_info?.message?.description}}</p>
                            </div>
                            <!-- Repost card end -->

                            <!--Activity Info-->
                            <div class="post-actions pt-1" *ngIf="callingfrom !== createRepostScreen && callingfrom !== createUserStoryScreen">
                                <div class="post-inline-status pb-2 clearfix">
                                    <span class="secondary-paragraph float-left"
                                        *ngIf="feedObject?.total_like==0"><span class="color-grey-500">{{mls.languageText.feed_card_screen.key12}}<span
                                            *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key12)</span></span></span>
                                    <span (click)="getProductLikeList();"
                                        *ngIf="feedObject?.total_like>0"
                                        class="secondary-paragraph cursor-pointer">
                                        <span class="color-grey-500">
                                        {{feedObject?.total_like}}
                                        {{(feedObject?.total_like==1)? mls.languageText.feed_card_screen.key5 : mls.languageText.feed_card_screen.key6}}<span
                                            *ngIf="mls?.is_lskey_display==1">(
                                            {{(feedObject?.total_like>1)? "feed_card_screen.key5" : "feed_card_screen.key6"}}
                                            )</span></span></span>
                                    <span *ngIf="feedObject?.total_comments>0 && feedObject?.comment_flag!='0'"
                                        class="comment-counts secondary-paragraph ml-2 float-right"><span class="color-grey-500">{{ feedObject?.total_comments }}{{feedObject?.total_comments==1 ? ' '+mls.languageText.feed_card_screen.key10 :  ' '+mls.languageText.feed_card_screen.key11}}<span
                                            *ngIf="mls?.is_lskey_display==1">(
                                            {{(feedObject?.total_comments==1)? "feed_card_screen.key10" : "feed_card_screen.key11"}}
                                            )</span></span></span>
                                </div>
                                <div class="-2"></div>

                                <!-- like bookmark share -->
                                <div class="row separator-line py-3">
                                    <div [class]="(this.mls.featureOnOffList.featureList.bookmark.value 
                                    || this.mls.featureOnOffList.featureList.share.value
                                    || this.mls.featureOnOffList.featureList.repost.value) || !mls.userLoginFlow ?'like col-3 d-flex align-items-center justify-content-center':'like col-12 d-flex align-items-center justify-content-center'">
                                        <span (click)="productLike();"
                                            [ngClass]="{'active' : feedObject?.like_status == 1}"
                                            class="cursor-pointer button alignment">
                                            <img src="assets/themes/icons/primary-loader.gif"
                                                alt="loading"
                                                width="20px"
                                                height="20px"
                                                *ngIf="feed_like_loader==true" />
                                            <img id="like"src="assets/themes/icons/like-white.svg"
                                                alt="like icon"
                                                *ngIf="feedObject?.like_status != 1 && feed_like_loader==false"
                                                width="19px" height="19px"/>
                                            <img id="like" src="assets/themes/icons/like-black.svg"
                                                alt="liked icon"
                                                *ngIf="feedObject?.like_status == 1 && feed_like_loader==false"
                                                width="19px" height="19px"/>
                                            <span class="left-margin color-grey-700"
                                                *ngIf="feedObject?.like_status!=1">{{mls.languageText.feed_card_screen.key5}}</span>
                                            <span class="left-margin color-grey-700"
                                                *ngIf="feedObject?.like_status==1">{{mls.languageText.feed_card_screen.key14}}</span>
                                        </span>
                                    </div>
                                    <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="col-3  d-flex align-items-center justify-content-center px-0">
                                        <span [ngClass]="{'active': feedObject?.is_bookmarked==1}"
                                            (click)="productBookmark(); funCollectionService.stopEventPropagation(); "
                                            class="cursor-pointer button alignment">
                                            <img src="assets/themes/icons/primary-loader.gif"
                                                alt="loading"
                                                width="20px"
                                                height="20px"
                                                *ngIf="feed_bookmark_loader==true" />
                                            <img id="bookmark" src="assets/themes/icons/bookmark-white.svg"
                                                alt="bookmark icon"
                                                *ngIf="feedObject?.is_bookmarked!=1 && feed_bookmark_loader==false"
                                                width="19px" height="19px"/>

                                            <img id="bookmark" src="assets/themes/icons/bookmark-black.svg"
                                                alt="bookmarked icon"
                                                *ngIf="feedObject?.is_bookmarked==1 && feed_bookmark_loader==false"
                                                width="19px" height="19px"/>
                                            <span class="left-margin color-grey-700"
                                                *ngIf="feedObject?.is_bookmarked!=1">{{mls.languageText.feed_card_screen.key7}}</span>
                                            <span class="left-margin color-grey-700"
                                                *ngIf="feedObject?.is_bookmarked==1">{{mls.languageText.feed_card_screen.key8}}</span>
                                        </span>
                                    </div>
                                    <div *ngIf="this.mls.featureOnOffList.featureList.repost.value || !mls.userLoginFlow" class="col-3 d-flex align-items-center justify-content-center">
                                        <app-repost-popover
                                            *ngIf="showRepostPopOver"
                                            [isInfoModalShown]="true"
                                            (emitStartRequest)="closeTagTutorial()"
                                            (emitHideModal)="closeTagTutorial()"
                                            [screenName]="screenName">
                                        </app-repost-popover>
                                        <span class="cursor-pointer button alignment"
                                            (click)="$event.stopPropagation(); feedRepostOption()">
                                            <img width="22px"
                                                src="assets/themes/icons/repost.svg" alt="icon-repost" class="mr-2">
                                                <span class="color-grey-700">{{mls.languageText.feed_card_screen.key17}}
                                                </span>
                                        </span>
                                        <app-repost-type-list-meta *ngIf="isMetaGenerated" [callingFrom]="'FEED_POSTING'" [productId]="feedObject?.feed_id" (emitRepostType)="repostFeedType($event)" (closeToolTip)="closeMeta($event)"></app-repost-type-list-meta>
                                    </div>
                                    <div *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow" class="col-3  d-flex align-items-center justify-content-center px-0">
                                        <div (click)="productShare()"
                                            class="cursor-pointer button alignment">
                                            <img src="assets/themes/icons/share.svg" alt="Share icon" />
                                            <span class="left-margin color-grey-700">{{mls.languageText.feed_card_screen.key9}}<span
                                                *ngIf="mls?.is_lskey_display==1">(feed_card_screen.key9)</span></span></div>
                                    </div>
                                </div>
                                <!--  end like bookmark share  -->

                            </div>
                        </div>
                    </div>
                </div>
                <!--************* comment **************************** (resetLikeModalList) = resetLikeModalList($event) [CommentObj]=CommentObj-->
                <ng-container *ngIf="callingfrom !== createRepostScreen && callingfrom !== createUserStoryScreen">
                    <div *ngIf="feedObject?.comment_flag!='0'"
                        [ngClass]="{'separator-line':this.feedObject?.total_comments>0}">
                        <app-product-comment
                            [callingFrom]="callingfrom"
                            (emitComment)="emitComment($event)"
                            [comment_box_obj]="comment_box_obj"
                            (shareCommentCountToParent)=shareCommentCountToParent($event)
                            (resetCmtList)="resetCmtList($event)"
                            *ngIf="feedObject?.comment_flag==1"
                            [commentObj]="commentObj"
                            [showCommentBox]="0"
                            [screen_name]="screen_name"
                            [is_activity]="is_activity"
                            [list_type]="commentListType.TOP"
                            (deleteTotalReplyComment)="deleteTotalReplyComment($event)">
                        </app-product-comment>
                    </div>

                    <div class="pt-3 px-3 separator-line separator-line" *ngIf="feedObject?.comment_flag!='0' ">
                        <app-product-comment-box
                            [callingFrom]="callingfrom"
                            *ngIf="feedObject?.comment_flag==1"
                            [comment_box_obj]="comment_box_obj"
                            (resetComment)="resetComment($event)"
                            [emitUserComment]="emitUserComment">
                        </app-product-comment-box>
                    </div>
                </ng-container>
                <!-- </span> -->
        </div>
    </div>
            <!-- ***********EOF comment **************************** -->
        </div>
        <!-- end new card design -->

    </div>
    <!--Calling Media PopUp Component-->
    <app-media-modal
        *ngIf="mediaModal==true"
        (resetMediaModal)="setResetMediaModal($event)"
        [isMediaModalShown]="mediaModal"
        [mediaObj]="feedObject?.media_list"
        [openMediaIndex]="openMediaIndex">
    </app-media-modal>
    <!--EOF Calling Media PopUp Component-->


    <!-- like list popup start**************************** -->
    <app-product-like
        *ngIf="showLikeListModal"
        (resetLikeModalList)="resetLikeModalList($event)"
        (resetLike)="resetLike($event) "
        [likeObj]="likeObj">
    </app-product-like>
    <!-- like list popup end ***************************** -->


    <!-- confirm modal for post delete start-->
    <app-confirm-modal
        *ngIf="isConfirmModalShown==true"
        (resetConfirmModal)="resetConfirmModal($event)"
        [isConfirmModalShown]="isConfirmModalShown"
        [confirmInfo]="confirmInfo">
    </app-confirm-modal>
    <!-- confirm modal for post delete end-->

    <!-- confirm modal for community post delete start-->
    <!-- step 1/step2-->
    <app-confirm-modal
        *ngIf="isDeleteConfirmModalStep1 || isDeleteConfirmModalStep2"
        (resetConfirmModal)="resetDeleteConfirmModal($event)"
        [isDeleteCommunityPostModalShown]="isDeleteConfirmModalStep1 || isDeleteConfirmModalStep2"
        [confirmInfo]="confirmInfo"
        (emitDeleteCommunityFeed)="onDeleteCommunityPostConfirm($event)"
        [deleteConfirm]="deleteConfirm">
    </app-confirm-modal>
    <!-- confirm modal for community post delete end-->

    <!-- subscribe popup start**************************** -->
    <!-- <app-product-subscribe *ngIf="showSubscribeModal==true" (resetProductSubscribeModal) = resetProductSubscribeModal($event) [showSubscribeModal]=showSubscribeModal [JournalData]=feedObject></app-product-subscribe>  -->
    <!-- subscribe popup end**************************** -->

    <!-- get sample start -->
    <app-product-get-sample
        *ngIf="isGetsampleModal==true"
        (resetProductGetsampleModal)="resetProductGetsampleModal($event)"
        [isGetsampleModal]="isGetsampleModal"
        [JournalData]="feedObject"
        [product_type]="1"
        [product_type_id]="feedObject?.feed_id">
    </app-product-get-sample>
    <!-- get sample end -->

    <!-- follow start-->

    <app-product-follow
        *ngIf="is_follow==true"
        (resetFollow)="resetFollow($event)"
        [followObj]="followObj">
    </app-product-follow>
    <!-- follow end -->
